module.exports = __webpack_public_path__ + "img/dollar.160ae115.svg";